import { useState, useEffect } from 'react'

export function useStandaloneMode(): boolean {
  const [isStandalone, setIsStandalone] = useState(() => {
    if (typeof window === 'undefined') return false
    // iOS standalone detection
    if ('standalone' in navigator && (navigator as { standalone: boolean }).standalone) {
      return true
    }
    // Standard display-mode detection
    return window.matchMedia('(display-mode: standalone)').matches
  })

  useEffect(() => {
    const mediaQuery = window.matchMedia('(display-mode: standalone)')

    function handleChange(e: MediaQueryListEvent) {
      setIsStandalone(e.matches)
    }

    setIsStandalone(
      mediaQuery.matches ||
      ('standalone' in navigator && !!(navigator as { standalone: boolean }).standalone)
    )

    mediaQuery.addEventListener('change', handleChange)
    return () => {
      mediaQuery.removeEventListener('change', handleChange)
    }
  }, [])

  return isStandalone
}
